<script>
import {useEvaluationPhaseStore} from "@/stores/Evaluation/EvaluationPhase.js"
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {computed, watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import axios from "axios";

export default {
    props: {
        type: String,
    },
    setup(props) {
        const {total, loading, filter,} = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {$i18n, $router} = useTools();

        const evaluationPhaseStore = useEvaluationPhaseStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.label"),
                align: "left",
                sortable: true,
                value: "name",
            },
            {
                text: $i18n.t('evaluation.evaluator'),
                align: "left",
                sortable: true,
                value: "evaluator",
            },
            {
                text: $i18n.t('module.worker'),
                align: "left",
                sortable: true,
                value: "workerName",
            },
            {
                text: $i18n.t("common.comment"),
                align: "left",
                sortable: true,
                value: "notes",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_EVALUATION_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_EVALUATION_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            filter.value.type = props.type;
            axios.get('/evaluationPhases', {params: transformFilterValues(filter.value)}).then((response) => {
                evaluationPhaseStore.setEvaluationPhases(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        const rootPath = computed(() => {
            if (props.type === 'EVALUATION_SKILL') {
                return 'evaluation_skill_phases';
            } else if (props.type === 'EVALUATION_PERFORMANCE') {
                return 'evaluation_performance_phases';
            }
        });

        function view(item) {
            $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }

        return {
            evaluationPhaseStore,
            rootPath,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            view,
            findAll,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t(`module.${rootPath}`)"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_EVALUATION_PARAM']"
                    @press="$router.push({ name: `${rootPath}.add` })"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="3">
                            <w-text-field
                                v-model="filter.name"
                                :label="$t('common.label')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="evaluationPhaseStore.evaluationPhases"
                    :total="total"
                    :loading="loading"
                    sort-by="note"
                    @rowDbClick="view"
                >

                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.evaluator`]="{ item }">
                        <w-inline-text :text="$t(`evaluation.${item.evaluator}`)"/>
                    </template>
                    <template v-slot:[`item.workerName`]="{ item }">
                        <w-inline-text :text="item.workerName"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
